import { useTranslation } from 'react-i18next';
import wildPhoto from '../static/images/wild_section.jpg';
import { Link } from 'react-router-dom';

const HomepageWildSection = () => {
    const {t, i18n} = useTranslation();
    return (
        <div className="w-full lg:w-[1000px] h-[400px] md:h-[900px] rounded-xl mt-16 flex justify-center items-center relative bg-cover bg-center" style={{ backgroundImage: `url(${wildPhoto})` }}>
            <div className='absolute top-[300px] md:top-[600px] right-0 bottom-0 left-0 p-4 bg-gradient-to-t from-slate-900 to-transparent flex flex-col justify-end items-center rounded-xl'> {/* bg-gradient-to-t from-slate-900 to-transparent */}
                <div className="flex flex-col md:flex-row items-center justify-center mb-4">
                    <div className='text-white text-2xl font-bold'>{t('Homepage.HomepageWildSection.doNot')}</div>
                    <div className={`font-signature text-[#fbd100] text-3xl md:text-7xl w-[140px] flex justify-center ${i18n.language === 'fr' && 'ml-8 mr-12'}`}>{t('Homepage.HomepageWildSection.wild')}</div>
                    <div className='text-white text-2xl font-bold'>{t('Homepage.HomepageWildSection.favourite')}</div>
                </div>
                <Link to="https://forms.gle/52rGLsdquxzniaDz6" target="_blank"><button className='mb-4 py-2 px-4 bg-[#b05704] rounded-xl text-neutral-200'>{t('Homepage.HomepageWildSection.shareWithUs')}</button></Link>
            </div>
        </div>
    )
}

export default HomepageWildSection;